import { useEffect } from 'react';
import axios from 'axios';
import { setUnitPriceFractionDigits } from '../utils/decimalInput';

const apiUrl = process.env.REACT_APP_API_URL ?? '';

// Module-level guard: Navbar mounts in more than one layout, but the setting is
// company-wide, so ONE fetch per page load is enough.
let _requested = false;

const useNumberFormatSettings = (): void => {
  useEffect(() => {
    if (_requested) return;
    const token = localStorage.getItem('token');
    if (!token) return;
    _requested = true;

    axios
      .get(`${apiUrl}/api/company-settings/number-format`, {
        headers: { 'x-auth-token': token },
      })
      .then((res) => {
        const digits = Number(res.data?.unitPriceDecimals);
        if (Number.isFinite(digits)) setUnitPriceFractionDigits(digits);
      })
      .catch(() => {
        // Silent background load — keep the default (4 decimals).
        _requested = false;
      });
  }, []);
};

export default useNumberFormatSettings;
